import { jsx as _jsx } from "react/jsx-runtime";
import { ContentOnly } from '../components/ContentOnly';
import { ContentWithPicture } from '../components/ContentWithPicture';
import { PictureOnly } from '../components/PictureOnly';
import { Title } from '../components/Title';
import { TitleContainer } from '../components/TitleContainer';
import { getContentVariant } from '../utils/getContentVariant';
import { getImageVariant } from '../utils/getImageVariant';
export const useGetVariant = (appHeaderProps) => {
    const { controls, coverPicture, coverPictureNarrow, coverPictureWide, description, disableCoverPicture, disableDescription, } = appHeaderProps;
    const { filteredControls, showContent, showControls, showDescription } = getContentVariant({
        controls,
        description,
        disableDescription,
    });
    const { coverPictureUrls, showPicture } = getImageVariant({
        coverPicture,
        coverPictureNarrow,
        coverPictureWide,
        disableCoverPicture,
        showContent,
    });
    if (showContent && showPicture) {
        return (_jsx(ContentWithPicture, Object.assign({ coverPictureUrls: coverPictureUrls, dataTestId: "app-header-content-with-picture", filteredControls: filteredControls, showContent: showContent, showControls: showControls, showDescription: showDescription, showPicture: showPicture }, appHeaderProps)));
    }
    if (showContent) {
        return (_jsx(ContentOnly, Object.assign({ dataTestId: "app-header-content-only", filteredControls: filteredControls, showControls: showControls, showDescription: showDescription }, appHeaderProps)));
    }
    if (showPicture) {
        return (_jsx(PictureOnly, { coverPictureUrls: coverPictureUrls, "data-testId": "app-header-picture-only", title: appHeaderProps.title }));
    }
    if (!showContent && !showPicture && appHeaderProps.title) {
        return (_jsx(TitleContainer, { dataTestId: "appheader-container", children: _jsx(Title, { title: appHeaderProps.title }) }));
    }
    return null;
};
//# sourceMappingURL=useGetVariant.js.map